<template>
    <transition name="fade" @after-enter="afterEnter">
        <div class="popup" style="background-image: url('static/img/main/point4/popup/bg.png');" ref="popup">
            <div class="popup-bg delay3"></div>
            <div class="popup-inner ">
                <a href="#" class="close" @click.prevent="closePopup"></a>
                <div class="left delay6">
                    <div class="quotes quotes-right">
                    <span class="text">
                        Солнечная Сицилия&nbsp;&mdash; очень красивый и&nbsp;разнообразный остров, омываемый тремя морями, который подарил мне редкую возможность полного слияния с&nbsp;природой
                    </span>
                    </div>
                    <div class="info">
                    <span class="point">
                        <span class="text">
                            Сицилия, Италия
                        </span>
                    </span>
                        <h3 class="head">
                            Солнечная Сицилия
                        </h3>
                        <span class="desc">
                            Сицилийские цитрусовые занимают важное место на рынке европейских фруктов: уже 150 лет назад лимонные плантации на острове были самым прибыльным сельскохозяйственным угодьем в Европе, превосходя даже знаменитые фруктовые сады в окрестностях Парижа. Сицилийские лимоны начали культивировать в XVIII веке, и они настолько душисты и сочны, что за их эфирное масло борются ведущие парфюмерные дома. А у Weleda на Сицилии есть сады, в которых биодинамическим способом выращивают органические лимоны. Местные лимоны дарят средствам марки заряд витамина C и яркий запах Средиземноморья.
                    </span>
                    </div>
                </div>
                <div class="right delay9">
                    <div class="popup-products">
                        <div class="info">
                            <h4 class="head">
                                Лимон
                            </h4>
                            <span class="desc">
                                Эфирное масло и сок лимона — одни из самых важных компонентов косметических средств. Бодрящие ароматы лимона помогают наполнить день позитивом и энергией.
                        </span>
                            <a href="https://www.weleda.ru/%D0%BA%D1%80%D0%B0%D1%81%D0%BE%D1%82%D0%B0-%D0%BE%D1%82-%D0%BF%D1%80%D0%B8%D1%80%D0%BE%D0%B4%D1%8B/%D0%B2%D0%B5%D0%B4%D1%83%D1%89%D0%B8%D0%B5-%D1%80%D0%B0%D1%81%D1%82%D0%B5%D0%BD%D0%B8%D1%8F/%D0%BB%D0%B8%D0%BC%D0%BE%D0%BD?utm_source=afisha&utm_medium=card&utm_content=lemon&utm_campaign=weleda_afisha_sp_summer_2018" target="_blank" class="btn" @click="gaEvents('places','click','know more ')">
                                Подробнее
                            </a>
                        </div>
                        <div class="img">
                            <img src="static/img/main/point4/popup/product.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import {TweenMax} from 'gsap';
    import  popupMix from '@/components/pages/popups/popup_mix.vue';

    export default {
        name: 'popup4',
        mixins: [popupMix],
    }
</script>



// WEBPACK FOOTER //
// popup4.vue?cd9f9274